module.exports = "../images/fishing-lodge-3-21.jpg?v=2dcc911";